import { pathWithoutId } from './routing';
import {Modal} from 'bootstrap';
const $ = jQuery.noConflict();

const LOADING_SPINNER = `
	<div class="evtx-loading fx--spinner">
		<i class="fa fa-circle-o-notch" aria-hidden="true"></i>
	</div>
`

const TOOLTIP_SELECTOR = '[data-toggle="tooltip"]';

const modalId = 'evtx-modal';
const modalEl = document.getElementById(modalId);
const modal = Modal.getOrCreateInstance(modalEl);
const $modal = $(`#${modalId}`);

const insertModalContent = (content) => {
	const $modal = $(`#${modalId}`);
	if (!$modal.length) {
		console.warn("can't find modal element #evtx-modal");
		return;
	}
	const $modalBody = $modal.find('.modal-body');
	if (!$modal.length) {
		console.warn("can't find modal element's body body");
		return;
	}
	$modalBody.html(content);
}

export function getPostData(postid) {
   if (!viewsEventName) return;

   var $modalBody = $modal.find('.modal-body');
	insertModalContent(LOADING_SPINNER);
   modal.show();

   $.ajax({
      type: 'POST',
      data: {
         action: 'get_modal_html',
         id: postid,
         eventContext: viewsEventName,
         theme: themeSettings,
      },
      url: ajaxurl,
      success: function (data) {
         $('.evtx-loading').addClass('invisible');
			insertModalContent(data);
      },
      error: function (xhr, status, err) {
			console.warn("Error fetching data from server.")
			modal.hide();
      },
   });
}


export function showPostModal(id) {
   id = id.toString();

   if ($modal.length) {
		try {
			if (window.postModalHTML
				&& window.postModalHTML[id]
			) {
				insertModalContent(
					window.postModalHTML[id]
				);
				modal.show();
			}
			else {
				getPostData(id);
			}
		}
		catch (e) {
			console.warn(e);
			getPostData(id);
		}
	}
   window.lastId = id;
}

export function hideModal(closeModal) {
   history.pushState(
      "",
      document.title,
      pathWithoutId() + location.hash,
   );
   window.lastId = null;
   if (closeModal === true) {
		modal.hide();
   }
}

export function setupModalEvents() {

	const modalElement = document.getElementById(modalId);

   // reset hash url when leaving modal window
	modalElement.addEventListener('hidden.bs.modal', function() {
		$(this).find('.wrap-media').html('');
		hideModal();
	});

	modalElement.addEventListener('shown.bs.modal', function() {
		// Initialize AddThis Toolbox, if it exists
      var atSelector = '.addthis_toolbox';
      var $addthis = $(atSelector);
      if ($addthis.length && window.addthis) {
         window.addthis.toolbox(atSelector);
      }
      else {
         $addthis.hide();
      }

		// Setup slick slider galleries within modal
      var $slick = $('#evtx-modal .evtx-gallery');
      if ($slick.length) {
         $slick.slick();
      }
	});



	// TODO: Fix the tooltips!
	modalElement.addEventListener('show.bs.modal', function () {
		// var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
		// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
		// 	return new bootstrap.Tooltip(tooltipTriggerEl)
		// })
      // $(this).find().tooltip();
      // $(this).find(TOOLTIP_SELECTOR).click(function (event) {
      //    event.stopPropagation();
      // });
	});

   $(function () {
      $(document).on("click", ".evtx-images-open-in-modal img", function (e) {
         e.preventDefault();
         e.stopPropagation();
         var src = $(this).attr('src');
			insertModalContent(`
				<div class="text-center">
					<img class="evtx-image-modal" src="${src}"/>
				</div>`,
			);
			modal.show();
      });
   });


}

/**
 * Pre-loads HTML for post popups
 * @param  {string} jQuery selector
 * @return {null}          stores popup data in object, returns nothing
 */
var modalPostData;
export function storePopupData(selector) {
   if (!viewsEventName) return;
   var allIds = [];
   $(selector).each(function () {
      allIds.push($(this).attr('data-post-id'));
   });

   $.ajax({
      type: 'POST',
      data: {
         action: 'get_modal_html',
         ids: allIds,
         eventContext: viewsEventName,
         theme: themeSettings,
      },
      url: ajaxurl,
      success: function (data) {
         modalPostData = data;
      },
      error: function (xhr, status, err) {
         console.error(this.props.url, status, err.toString());
         modal.hide();
      },
   });
}